<template>
  <div class="contact-box">
    <van-nav-bar title="报名缴费" left-text="返回" :fixed="true" left-arrow @click-left="onClickLeft" />
  </div>
</template>

<script>
  import { NavBar, Icon, Row, Col, DropdownMenu, DropdownItem } from 'vant';
  export default {
    props: {
      meetingId: {
        type: String,
      },
      meetingRegisterId: {
        type: String,
      },
    },
    data() {
      return {
        type: '',
        sourceName: null
      };
      title: "";
    },
    components: {
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Row.name]: Row,
      [Col.name]: Col,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
    },

    methods: {
      go(pathName) {
        this.$router.push({ name: pathName });
      },
      onClickLeft() {
        console.log(this.type)
        if (this.sourceName == "signup") { //如果是支付页面返回到报名修改页 
          this.$router.push({
            name: "changePage",
            query: {
              meetingId: this.meetingId,
              meetingRegisterId: this.meetingRegisterId,
              loginStatus: true
            },
          })
        } else {
          history.go(-1);
        }
      },
    },
    mounted() {
      this.type = this.$route.query && this.$route.query.route;
      this.sourceName = this.$route.query && this.$route.query.sourceName;
    }
  };
</script>

<style lang="less" scoped>
  /deep/.van-nav-bar {
    background: #fff;
    border-bottom: none;
    z-index: 999;
  }

  /deep/.van-dropdown-menu {
    background: none;
  }

  /deep/.van-dropdown-menu__title {
    color: #fff !important;
  }

  /deep/.van-dropdown-menu__title::after {
    display: none;
  }

  .sign_out {
    color: #fff;
  }

  /deep/.van-nav-bar .van-icon {
    color: #000;
    margin-top: -2px;
  }
</style>